(function () {
  'use strict';

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(root) {
    if (!root || root.dataset.stReady === '1') return;
    root.dataset.stReady = '1';

    var nodes = root.querySelectorAll('[data-st-reveal]');
    if (!nodes.length) return;

    if (reducedMotion() || !('IntersectionObserver' in window)) {
      nodes.forEach(function (node) {
        node.classList.add('is-in');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.22, rootMargin: '0px 0px -8% 0px' });

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-science-timeline]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-science-timeline]')
      : null;
    if (section) {
      section.dataset.stReady = '';
      init(section);
    } else if (event.target && event.target.matches && event.target.matches('[data-science-timeline]')) {
      event.target.dataset.stReady = '';
      init(event.target);
    }
  });
})();
